import {useState, useRef} from 'react'
import {callIfFunction} from '@startlibs/utils'

export const useGetState = (initial) => {

  const [state,rawSetState] = useState(initial)
  const stateRef = useRef(initial)

  const setState = (newState) => {
    const nextState = callIfFunction(newState,stateRef.current)
    stateRef.current = nextState
    rawSetState(nextState)
  }

  const getState = () => stateRef.current

  return [state,setState,getState]

}